var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 4,
    viewBox: "0 0 13 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "..."
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.615 0C2.071 0 2.45733 0.158333 2.774 0.475C3.09067 0.791667 3.249 1.17167 3.249 1.615C3.249 2.05833 3.09067 2.44467 2.774 2.774C2.45733 3.09067 2.071 3.249 1.615 3.249C1.17167 3.249 0.791667 3.09067 0.475 2.774C0.158333 2.44467 0 2.05833 0 1.615C0 1.17167 0.158333 0.791667 0.475 0.475C0.791667 0.158333 1.17167 0 1.615 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17945 0C6.63545 0 7.02179 0.158333 7.33845 0.475C7.65512 0.791667 7.81345 1.17167 7.81345 1.615C7.81345 2.05833 7.65512 2.44467 7.33845 2.774C7.02179 3.09067 6.63545 3.249 6.17945 3.249C5.73612 3.249 5.35612 3.09067 5.03945 2.774C4.72279 2.44467 4.56445 2.05833 4.56445 1.615C4.56445 1.17167 4.72279 0.791667 5.03945 0.475C5.35612 0.158333 5.73612 0 6.17945 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7439 0C11.1999 0 11.5862 0.158333 11.9029 0.475C12.2196 0.791667 12.3779 1.17167 12.3779 1.615C12.3779 2.05833 12.2196 2.44467 11.9029 2.774C11.5862 3.09067 11.1999 3.249 10.7439 3.249C10.3006 3.249 9.92057 3.09067 9.60391 2.774C9.28724 2.44467 9.12891 2.05833 9.12891 1.615C9.12891 1.17167 9.28724 0.791667 9.60391 0.475C9.92057 0.158333 10.3006 0 10.7439 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.4ab69af590893e1af040e2a8efacd73a.svg";
export { ForwardRef as ReactComponent };